export class QueryBuilder {
    private readonly params: Record<string, any>;

    constructor(params?: Record<string, any>) {
        this.params = params ?? {};
    }

    static from(params?: Record<string, any>): QueryBuilder {
        return new QueryBuilder(params);
    }

    build(): string {
        const searchParams = new URLSearchParams();

        Object.entries(this.params).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return;

            if (typeof value === 'object') {
                Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                    if (
                        nestedValue !== undefined &&
                        nestedValue !== null &&
                        nestedValue !== ''
                    ) {
                        searchParams.append(
                            nestedKey,
                            String(nestedValue),
                        );
                    }
                });

                return;
            }

            searchParams.append(key, String(value));
        });

        const query = searchParams.toString();

        return query ? `?${query}` : '';
    }
}